// Import SPA AngularJS 1.x integration setup.
import '@app/v1_integration/downgrades';
import * as appV1 from '@app/v1_integration';

// AngularX
import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from '@app/app.module';
import {environment} from 'environments/environment';

if (environment.production) {
  enableProdMode();
}

// Dynamic loading of metadata JS file
// before bootstrapping SPA v1
jQuery
  .getScript(environment.webApi_BreezeMetadataUrl)
  .then((data, textStatus, jqXHT) => {
    jQuery(document).ready(() => {
      const selectedElms = jQuery(appV1.APP_CSS_ROOT_CLASS_SELECTOR);
      if (selectedElms && selectedElms.length > 0) {
        platformBrowserDynamic()
          .bootstrapModule(AppModule)
          .then(ngModuleRef => {
            // Force routing to occur after bootstrapping.
            ngModuleRef.instance.forceTriggerRouting();
          })
          .catch(err => console.log(err));
      }
    });
  })
  .fail(function(jqxhr, settings, exception) {
    alert('Metadata failed to load.');
    throw new Error('Metadata failed to load.');
  });
